import ListOfAdvantages from './ListOfAdvantages';
export default ListOfAdvantages;